import React from 'react';
import { makeStyles } from '@mui/styles';

import palette from './styles/palette';
import loader from '../assets/gifs/loader.gif';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    backgroundColor: palette.typography.black.medium,
    position: 'fixed',
    zIndex: 9999,
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  progress: {
    color: palette.typography.white.solid,
  },
});

const LoadingOverlay = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <img src={loader} alt="loading..." />
    </div>
  );
};

export default LoadingOverlay;
